import type { TranslationKeysCountry } from '../localeType';

export const ptPT_country: TranslationKeysCountry = {
  AD: 'Andorra',
  AE: 'Emirados Árabes Unidos',
  AF: 'Afeganistão',
  AG: 'Antígua e Barbuda',
  AI: 'Enguia',
  AL: 'Albânia',
  AM: 'Armênia',
  AO: 'Angola',
  AQ: 'Antártica',
  AR: 'Argentina',
  AS: 'Samoa Americana',
  AT: 'Áustria',
  AU: 'Austrália',
  AW: 'Aruba',
  AX: 'Ilhas',
  AZ: 'Azerbaijão',
  BA: 'Bósnia e Herzegovina',
  BB: 'Barbados',
  BD: 'Bangladesh',
  BE: 'Bélgica',
  BF: 'Burkina Faso',
  BG: 'Bulgária',
  BH: 'Bahrein',
  BI: 'Burundi',
  BJ: 'Benim',
  BL: 'São Bartolomeu',
  BM: 'Bermudas',
  BN: 'Brunei Darussalam',
  BO: 'Bolívia, Estado Plurinacional de',
  BQ: 'Bonaire, Santo Eustáquio e Saba',
  BR: 'Brasil',
  BS: 'Bahamas',
  BT: 'Butão',
  BV: 'Ilha Bouvet',
  BW: 'Botsuana',
  BY: 'Bielorrússia',
  BZ: 'Belize',
  CA: 'Canadá',
  CC: 'Ilhas Cocos (Keeling)',
  CD: 'Congo, República Democrática do',
  CF: 'República Centro-Africana',
  CG: 'Congo',
  CH: 'Suíça',
  CI: 'Costa do Marfim',
  CK: 'Ilhas Cook',
  CL: 'Chile',
  CM: 'Camarões',
  CN: 'China',
  CO: 'Colômbia',
  CR: 'Costa Rica',
  CU: 'Cuba',
  CV: 'Cabo Verde',
  CW: 'Curaçao',
  CX: 'Ilha do Natal',
  CY: 'Chipre',
  CZ: 'República Checa',
  DE: 'Alemanha',
  DJ: 'Djibuti',
  DK: 'Dinamarca',
  DM: 'Domínica',
  DO: 'República Dominicana',
  DZ: 'Argélia',
  EC: 'Equador',
  EE: 'Estónia',
  EG: 'Egito',
  EH: 'Saara Ocidental',
  ER: 'Eritreia',
  ES: 'Espanha',
  ET: 'Etiópia',
  FI: 'Finlândia',
  FJ: 'Fiji',
  FK: 'Ilhas Malvinas (Falkland)',
  FM: 'Micronésia, Estados Federados de',
  FO: 'Ilhas Faroé',
  FR: 'França',
  GA: 'Gabão',
  GB: 'Reino Unido',
  GD: 'Granada',
  GE: 'Geórgia',
  GF: 'Guiana Francesa',
  GG: 'Guernsey',
  GH: 'Gana',
  GI: 'Gibraltar',
  GL: 'Groenlândia',
  GM: 'Gâmbia',
  GN: 'Guiné',
  GP: 'Guadalupe',
  GQ: 'Guiné Equatorial',
  GR: 'Grécia',
  GS: 'Geórgia do Sul e Ilhas Sandwich do Sul',
  GT: 'Guatemala',
  GU: 'Guam',
  GW: 'Guiné-Bissau',
  GY: 'Guiana',
  HK: 'Hong Kong',
  HM: 'Ilha Heard e Ilhas McDonald',
  HN: 'Honduras',
  HR: 'Croácia',
  HT: 'Haiti',
  HU: 'Hungria',
  ID: 'Indonésia',
  IE: 'Irlanda',
  IL: 'Israel',
  IM: 'Ilha de Man',
  IN: 'Índia',
  IO: 'Território Britânico do Oceano Índico',
  IQ: 'Iraque',
  IR: 'Irã, República Islâmica de',
  IS: 'Islândia',
  IT: 'Itália',
  JE: 'Jersey',
  JM: 'Jamaica',
  JO: 'Jordânia',
  JP: 'Japão',
  KE: 'Quênia',
  KG: 'Quirguistão',
  KH: 'Camboja',
  KI: 'Quiribati',
  KM: 'Comores',
  KN: 'São Cristóvão e Nevis',
  KP: 'Coreia, República Popular Democrática da',
  KR: 'Coreia, República da',
  KW: 'Kuwait',
  KY: 'Ilhas Cayman',
  KZ: 'Cazaquistão',
  LA: 'República Democrática Popular do Laos',
  LB: 'Líbano',
  LC: 'Santa Lúcia',
  LI: 'Liechtenstein',
  LK: 'Sri Lanca',
  LR: 'Libéria',
  LS: 'Lesoto',
  LT: 'Lituânia',
  LU: 'Luxemburgo',
  LV: 'Letónia',
  LY: 'Líbia',
  MA: 'Marrocos',
  MC: 'Mônaco',
  MD: 'Moldávia, República da',
  ME: 'Montenegro',
  MF: 'Saint Martin (parte francesa)',
  MG: 'Madagáscar',
  MH: 'Ilhas Marshall',
  MK: 'Macedónia, Antiga República Jugoslava de',
  ML: 'Mali',
  MM: 'Mianmar',
  MN: 'Mongólia',
  MO: 'Macau',
  MP: 'Ilhas Marianas do Norte',
  MQ: 'Martinica',
  MR: 'Mauritânia',
  MS: 'Monserrat',
  MT: 'Malta',
  MU: 'Maurício',
  MV: 'Maldivas',
  MW: 'Malaui',
  MX: 'México',
  MY: 'Malásia',
  MZ: 'Moçambique',
  NA: 'Namíbia',
  NC: 'Nova Caledônia',
  NE: 'Níger',
  NF: 'Ilha Norfolk',
  NG: 'Nigéria',
  NI: 'Nicarágua',
  NL: 'Holanda',
  NO: 'Noruega',
  NP: 'Nepal',
  NR: 'Nauru',
  NU: 'Niue',
  NY: 'Chipre (Turquia)',
  NZ: 'Nova Zelândia',
  OM: 'Omã',
  PA: 'Panamá',
  PE: 'Peru',
  PF: 'Polinésia Francesa',
  PG: 'Papua Nova Guiné',
  PH: 'Filipinas',
  PK: 'Paquistão',
  PL: 'Polónia',
  PM: 'São Pedro e Miquelon',
  PN: 'Pitcairn',
  PR: 'Porto Rico',
  PS: 'Palestina, Estado de',
  PT: 'Portugal',
  PW: 'Palau',
  PY: 'Paraguai',
  QA: 'Catar',
  RE: 'Reunião',
  RO: 'Romênia',
  RS: 'Sérvia',
  RU: 'Federação Russa',
  RW: 'Ruanda',
  SA: 'Arábia Saudita',
  SB: 'Ilhas Salomão',
  SC: 'Seicheles',
  SD: 'Sudão',
  SE: 'Suécia',
  SG: 'Singapura',
  SH: 'Santa Helena, Ascensão e Tristão da Cunha',
  SI: 'Eslovénia',
  SJ: 'Svalbard e Jan Mayen',
  SK: 'Eslováquia',
  SL: 'Serra Leoa',
  SM: 'São Marino',
  SN: 'Senegal',
  SO: 'Somália',
  SR: 'Surinome',
  SS: 'Sudão do Sul',
  ST: 'São Tomé e Príncipe',
  SV: 'El Salvador',
  SX: 'Sint Maarten (parte holandesa)',
  SY: 'República Árabe Síria',
  SZ: 'Suazilândia',
  TC: 'Ilhas Turcas e Caicos',
  TD: 'Chade',
  TF: 'Territórios Franceses do Sul',
  TG: 'Togo',
  TH: 'Tailândia',
  TJ: 'Tajiquistão',
  TK: 'Tokelau',
  TL: 'Timor Leste',
  TM: 'Turquemenistão',
  TN: 'Tunísia',
  TO: 'Tonga',
  TR: 'Turquia',
  TT: 'Trindade e Tobago',
  TV: 'Tuvalu',
  TW: 'Taiwan, Província da China',
  TZ: 'Tanzânia, República Unida da',
  UA: 'Ucrânia',
  UG: 'Uganda',
  UK: 'Reino Unido',
  UM: 'Ilhas Menores Distantes dos Estados Unidos',
  US: 'Estados Unidos',
  UY: 'Uruguai',
  UZ: 'Uzbequistão',
  VA: 'Santa Sé (Estado da Cidade do Vaticano)',
  VC: 'São Vicente e Granadinas',
  VE: 'Venezuela, República Bolivariana de',
  VG: 'Ilhas Virgens Britânicas',
  VI: 'Ilhas Virgens, EUA',
  VN: 'Vietnã',
  VU: 'Vanuatu',
  WF: 'Wallis e Futuna',
  WS: 'Samoa',
  YE: 'Iêmen',
  YT: 'Maiote',
  ZA: 'África do Sul',
  ZM: 'Zâmbia',
  ZW: 'Zimbábue',
};
